import { Configuration } from "@azure/msal-browser";
import { appInsights as AI, RegisterApplicationInsights } from "./AppInsight";

export interface IConstants {
    env: 'Development' | 'System' | 'Production';

    portal: {
        baseUrl: string;
        scopes: string[];
    }
    crm: {
        baseUrl: string;
        scopes: string[];
    }
    appInsights: {
        connectionString: string | null;
    }
    app: {
        authorizationStorageKey: string;
        groupLibraryURL: string;
        crmAppId: string;
        version: string | undefined;
        isLocalHost: boolean;
        cacheKey: string | null;
    },
    msalConfig: Configuration,
    initialize: () => Promise<IConstants>;
}

const constants: IConstants = {
    env: "Development",
    crm: {
        baseUrl: 'https://bcbsonlinedev.crm.dynamics.com',
        scopes: ['https://bcbsonlinedev.crm.dynamics.com/user_impersonation'],
    },
    portal: {
        baseUrl: 'https://localhost:44350',
        scopes: ['api://b3d9d9e7-a44b-4a50-84d4-6bf38ab844cd/Users']
    },
    appInsights: {
        connectionString: null
    },
    app: {
        authorizationStorageKey: "authentication",
        groupLibraryURL: 'https://app-dev-eastus.grouplibrary.bcbssc.com',
        crmAppId: '975825e9-352c-ec11-b6e5-000d3a5b93e5',
        version: process.env.REACT_APP_VERSION,
        isLocalHost: window.location.hostname.indexOf('local') >= 0,
        cacheKey: null
    },
    msalConfig: {
        auth: {
            clientId: "fa05cbcb-4226-4fc7-918f-201882dbc0ac",
            redirectUri: "https://localhost:44350/",
            authority: "https://login.microsoftonline.com/d560165e-85d7-436f-a978-c588cf12ebe1",
        },
        cache: {
            // localStorage or sessionStorage - choose localStorage to make sure new tabs are pre-authed
            cacheLocation: "localStorage",
            storeAuthStateInCookie: false,
        },
    },

    initialize: async () => {

        const addWebAppSettingsAsync = async () => {

            const updateEnvironment = (environment: string) => {
                if (environment === 'Production') {
                    constants.env = environment;
                    constants.crm.baseUrl = 'https://bcbsonline.crm.dynamics.com';
                    constants.crm.scopes = ['https://bcbsonline.crm.dynamics.com/user_impersonation'];
                    constants.app.crmAppId = 'be2013bc-a215-ed11-b83c-00224820a835';
                    constants.app.groupLibraryURL = 'https://app-prod-eastus.grouplibrary.bcbssc.com';
                    constants.portal.baseUrl = 'https://app-prod-eastus.grouplibrary.bcbssc.com';
                    constants.portal.scopes = ['api://4950e82c-3c15-4b64-8764-48b2a51ab48c/Users'];
                    constants.appInsights.connectionString = 'InstrumentationKey=e321f149-2e03-4b90-8612-62dd827244a2;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/';
                    constants.msalConfig.auth.redirectUri = 'https://app-prod-eastus.grouplibrary.bcbssc.com';
                    constants.msalConfig.auth.clientId = '4d85e837-ef84-4486-8d44-c9c7e99449c8';
                } else if (environment === 'System') {
                    constants.env = environment;
                    constants.crm.baseUrl = 'https://bcbsonlinesys.crm.dynamics.com';
                    constants.crm.scopes = ['https://bcbsonlinesys.crm.dynamics.com/user_impersonation'];
                    constants.app.crmAppId = 'be2013bc-a215-ed11-b83c-00224820a835';
                    constants.app.groupLibraryURL = 'https://app-sys-eastus.grouplibrary.bcbssc.com';
                    constants.portal.baseUrl = 'https://app-sys-eastus.grouplibrary.bcbssc.com';
                    constants.portal.scopes = ['api://b3d9d9e7-a44b-4a50-84d4-6bf38ab844cd/Users'];
                    constants.appInsights.connectionString = 'InstrumentationKey=64b6f119-5016-4f2b-bf28-5005eb07dce9;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/';
                    constants.msalConfig.auth.redirectUri = 'https://app-sys-eastus.grouplibrary.bcbssc.com/';
                    constants.msalConfig.auth.clientId = 'fa05cbcb-4226-4fc7-918f-201882dbc0ac';
                } else if (environment === 'Development') {
                    constants.env = environment;
                    constants.crm.baseUrl = 'https://bcbsonlinedev.crm.dynamics.com';
                    constants.crm.scopes = ['https://bcbsonlinedev.crm.dynamics.com/user_impersonation'];
                    constants.app.crmAppId = '1d3e2423-40b4-46b0-962f-d436676c9415';
                    constants.app.groupLibraryURL = 'https://app-dev-eastus.grouplibrary.bcbssc.com';
                    constants.portal.baseUrl = 'https://app-dev-eastus.grouplibrary.bcbssc.com';
                    constants.portal.scopes = ['api://b3d9d9e7-a44b-4a50-84d4-6bf38ab844cd/Users'];
                    constants.appInsights.connectionString = 'InstrumentationKey=3c01eb62-0809-414a-a849-cb440587cddf;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/';
                    constants.msalConfig.auth.redirectUri = 'https://app-dev-eastus.grouplibrary.bcbssc.com/';
                    constants.msalConfig.auth.clientId = 'fa05cbcb-4226-4fc7-918f-201882dbc0ac';
                }


                if (window.location.hostname.indexOf('local') >= 0) {

                    // Faking dev redirection for prod case, currently prod is not authenticating msal with localhost redirect.
                    // we can remove this if that is ever setup properly.
                    constants.portal = {
                        baseUrl: 'https://localhost:44350',
                        scopes: ['api://b3d9d9e7-a44b-4a50-84d4-6bf38ab844cd/Users']
                    };

                    constants.msalConfig = {
                        auth: {
                            clientId: "fa05cbcb-4226-4fc7-918f-201882dbc0ac",
                            redirectUri: "https://localhost:44350/",
                            authority: "https://login.microsoftonline.com/d560165e-85d7-436f-a978-c588cf12ebe1",
                        },
                        cache: {
                            // localStorage or sessionStorage - choose localStorage to make sure new tabs are pre-authed
                            cacheLocation: "localStorage",
                            storeAuthStateInCookie: false,
                        },
                    };
                }

                console.log(`[appl] Constants.updateEnvironment`, environment);
                return constants;

            }

            const configFetch = await fetch('/api/config/EnvironmentName');
            if (configFetch.ok) {
                const configJson = await configFetch.json();
                updateEnvironment(configJson.environmentName);
            } else {
                const configText = await configFetch.text();
                throw new Error(configText);
            }
        }

        const addApplicationInsights = async () => {
            if (constants.appInsights.connectionString) {
                RegisterApplicationInsights(constants.appInsights.connectionString)
            } else {
                console.warn("Application Insights is not ready.");
            }
        }

        const addCacheInfo = async () => {

            // supported by browser?
            if (!window.caches)
                return;

            // cache maintenance
            const cacheKeys = await window.caches.keys();

            // delete old caches that start with app and are not the current cache
            await Promise.all(cacheKeys
                .filter(key => key.startsWith('app.') && !key.startsWith(constants?.app?.cacheKey!))
                .map(key => window.caches.delete(key)));

        }

        await addWebAppSettingsAsync();
        await addApplicationInsights();
        await addCacheInfo();

        return constants;
    }

};


export const Constants = constants;

